export default {
  getMessageConfirmation () {
    return {
      cancel: 'Cancelar',
      label: 'Remover',
      title: 'Confirmar Remoção',
      message: 'Deseja remover o covênio <strong>' + this.currentEntity.name + '</strong>?'
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/covenants/index/resources/computed.js